import { useState, useCallback } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useEditGracePeriod(pluginId, gracePeriod, refresh) {
  const { logError } = useLogger({ prefix: "useEditGracePeriod" });
  const { makeAuthedRequest } = Auth.useContainer();

  const [isWaiting, setIsWaiting] = useState(false);
  const [iboNumber, setIboNumber] = useState(gracePeriod.iboNumber);
  const [graceAward, setGraceAward] = useState(gracePeriod.graceAward);
  const [newAward, setNewAward] = useState(gracePeriod.newAward);
  const [periodStart, setPeriodStart] = useState(gracePeriod.periodStart);
  const [periodEnd, setPeriodEnd] = useState(gracePeriod.periodEnd);
  const [notes, setNotes] = useState(gracePeriod.notes);

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const body = JSON.stringify({
      id: Number(gracePeriod.id),
      iboNumber: Number(iboNumber),
      graceAward: Number(graceAward),
      newAward: Number(newAward),
      periodStart: periodStart,
      periodEnd: periodEnd,
      yearsDiamondPlus: Number(gracePeriod.yearsDiamondPlus),
      notes: notes.trim(),
    });

    return makeAuthedRequest(`/v1/membership/loa/graceperiod/${pluginId}`, {
      method: "PUT",
      body: body,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .catch(logError)
      .finally(() => {
        refresh();
        setIsWaiting(false);
      });
  }, [
    graceAward,
    newAward,
    notes,
    periodStart,
    periodEnd,
    pluginId,
    gracePeriod,
    iboNumber,
    makeAuthedRequest,
    logError,
    refresh,
  ]);

  return {
    submit,
    isWaiting,

    iboNumber,
    setIboNumber,

    graceAward,
    setGraceAward,

    newAward,
    setNewAward,

    notes,
    setNotes,

    periodStart,
    setPeriodStart,

    periodEnd,
    setPeriodEnd,
  };
}
